export const MoreFieldsAlertTexts = {
  subtitle: 'Чем больше полей вы заполните, тем больше предложений получите от банков',
  avitoSubtitle: 'Заполните все данные, чтобы получить больше предложений от банков',
};
